/**
 * The system back button, in a browser and in the web app installed on a
 * phone's home screen.
 *
 * The Android app catches back itself (MainActivity → store.goBack). A web
 * page cannot: back walks the browser's history, and the app never wrote
 * anything there — so on the many phones running the installed web version,
 * back from inside a chat closed Pine instead of going back to the list.
 *
 * So while anything is open that back should close — a chat, its info, a
 * dialog, a story — one entry of ours sits on top of the history. Back takes
 * it off; we close the top thing, and put an entry back if there is still
 * something open. Closing things by tapping takes our entry off again, so
 * the history never fills up with them.
 */
export function syncBackWithHistory (store) {
  if (typeof window === 'undefined' || !window.history || !store.platform || store.platform.kind !== 'web') {
    return () => {}
  }
  let armed = false
  let ignore = 0

  const update = () => {
    const open = store.canGoBack()
    if (open && !armed) {
      armed = true
      window.history.pushState({ pineBack: true }, '')
    } else if (!open && armed) {
      armed = false
      ignore++
      window.history.back()
    }
  }

  const onPop = () => {
    if (ignore) { ignore--; return }
    if (!armed) return // back past our entry: the browser's own business
    armed = false
    store.goBack()
    update()
  }

  window.addEventListener('popstate', onPop)
  const off = store.subscribe(update)
  update()
  return () => {
    window.removeEventListener('popstate', onPop)
    off()
  }
}
